// extracted by mini-css-extract-plugin
module.exports = {"grid":"fixed-sidebar_grid__GuEpo"};